import * as PIXI from 'pixi.js'
import { DropShadowFilter } from 'pixi-filters'

PIXI.settings.TARGET_FPMS = 0.01
PIXI.settings.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = false
PIXI.utils.skipHello()

export function initStage(div, width, height) {
  const pixiApp = new PIXI.Application({
    width: width,
    height: height,
    transparent: true,
    sortableChildren: true,
    enableSort: true,
    antialias: false,
    sharedTicker: true
  })

  pixiApp.renderer.plugins.interaction.autoPreventDefault = false
  pixiApp.renderer.view.style.touchAction = 'auto'
  pixiApp.renderer.antialias = false
  pixiApp.renderer.preserveDrawingBuffer = true
  pixiApp.autostart = true
  pixiApp.sharedTicker = true

  const container = new PIXI.Container()
  container.filters = [initShadowFilter()]
  container.sortableChildren = true
  pixiApp.stage.addChild(container)
  div.appendChild(pixiApp.view)
  const loader = PIXI.Loader.shared
  container.ticker = pixiApp.ticker
  container.loader = loader
  const renderer = PIXI.autoDetectRenderer()

  return [pixiApp, container, pixiApp.ticker, loader, renderer]
}

function initShadowFilter() {
  const dropShadowFilter = new DropShadowFilter()

  dropShadowFilter.color = 0x000020
  dropShadowFilter.alpha = 0.2
  dropShadowFilter.blur = 3
  dropShadowFilter.distance = 10
  dropShadowFilter.rotation = -15
  dropShadowFilter.quality = 3

  return dropShadowFilter
}
